import { createFileRoute } from "@tanstack/react-router";

import { RunJobPage } from "@/routes/run-job";

export const Route = createFileRoute("/run-workloads")({
  head: () => ({ meta: [{ title: "Run Workloads · GENRL" }] }),
  component: RunJobPage,
});
